// extracted by css-extract-rspack-plugin
export default {"field":"field-Wvs1t1","success-icon":"success-icon-3FCOHB","successIcon":"success-icon-3FCOHB","cross-icon":"cross-icon-cqszZl","crossIcon":"cross-icon-cqszZl"};